export default __webpack_public_path__ + "static/media/Accounting-02.745e4d83.png";